/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Driver_RemittancesInputs */

const vi_nav_driver_remittances = /** @type {(inputs: Nav_Driver_RemittancesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nộp quỹ`)
};

/**

* @param {Nav_Driver_RemittancesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_driver_remittances = /** @type {((inputs?: Nav_Driver_RemittancesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Driver_RemittancesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_driver_remittances(inputs)
});